<form>
  <div class="display-flex mt-10">
    <div class="label-item"><label>Select Form:</label></div>
    <div class="form-item">
      <select
        gtwSearchableSelect
        class="form-control"
        [(ngModel)]="formId"
        (ngModelChange)="formChanged($event)"
        name="formSelect">
        <option value="" disabled>-- Select Form --</option>
        @for (av of availableList; track $index) {
<option [value]="formItemId(av)">{{ formItemLabel(av) }}</option>
}
      </select>
    </div>
  </div>
  <div class="display-flex mt-10">
    <button
      class="btn btn-info"
      (click)="deleteForm()"
      [disabled]="!formId || loading">
      Delete Form
      @if (loading) {
<span><i class="fa fa-spin fa-spinner"></i></span>
}
    </button>
  </div>
</form>
<div class="table-container">
  @if (!loadingGrid) {
<div class="table-content">
    @if (formElements.length > 0) {
<div class="search-row mt-10">
      <input
        type="text"
        class="form-control search-input"
        placeholder="Search table..."
        [(ngModel)]="searchFilter"
        name="searchFilter" />
    </div>
}
    @if (filteredFormElements.length > 0) {
<div class="table-scroll">
      <table>
        <thead>
          <tr>
            @for (col of tableColumns; track $index) {
<th
                class="sortable-header"
                (click)="sortBy(col.field)">
              <span>{{ col.title }}</span>
              <i class="fa" [ngClass]="getSortIconClass(col.field)"></i>
            </th>
}
          </tr>
        </thead>
        <tbody>
          @for (row of filteredFormElements; track $index) {
<tr>
            <td>{{ row.ELEMENT_NAME }}</td>
            <td>{{ row.SNO }}</td>
            <td>{{ row.ELEMENT_VALUE }}</td>
          </tr>
}
        </tbody>
      </table>
    </div>
}
    @if (formElements.length > 0 && filteredFormElements.length === 0) {
<div class="no-results">
      No matching results.
    </div>
}
  </div>
}
  @if (loadingGrid) {
<div class="loader">
    <i class="fa fa-spinner fa-spin fa-4x"></i>
  </div>
}
</div>
